import React from "react";
import "../styles/ProjectView.css";

function ProjectView() {
  return (
    <div>
      {/* container */}
      {/* project 1 */}
      <div className="projectview__project">
        <div className="projectview__picture">
          <img alt="project 1 profile" src="netflixCloneDemo.jpg" />
        </div>
        <div className="projectview__info">
          <a href="https://netflix-clone-1b665.web.app/">
            <h1>Netflix Clone</h1>
          </a>
          <h3>ReactJS / Firebase / API's</h3>
          <p>
            Created a clone application of a Netflix. The app does not stream full movies, but
            instead plays trailers of the selected movies. I used Firebase to host and deploy the
            app, ReactJS as the frontend, and Axios to make fetch calls to TMDB API for all the
            latest movies!
          </p>
        </div>
      </div>
      <hr />
      {/* project 2 */}
      <div className="projectview__project">
        {/* info */}
        <div className="projectview__info">
          <a href="https://messengerclone-6acc9.web.app/">
            <h1>Messenger Clone</h1>
          </a>
          <h3>ReactJS / Firebase / REST </h3>
          <p>
            This was a clone application of the famous facebook messenger chat service. It utilized
            Firebase database with a ReactJS front-end to allow users to chat with one another. Feel
            free to hop in and add some messages! (No login required!)
          </p>
        </div>
        {/* pic */}
        <div className="projectview__picture">
          <img alt="project 2 profile" src="messengerCloneDemo.png" />
        </div>
      </div>
      <hr />
      {/* Project 3 */}
      <div className="projectview__project">
        <div className="projectview__picture">
          <img alt="project 3 demo" src="stockAppDemo.jpg" />
        </div>
        <div className="projectview__info">
          <h1>Stock Info APP</h1>
          <h3>HTML / CSS / jQuery / API's</h3>
          <p>
            This app allows the user to pick a stock and get back all the relevant market data of
            the day. Though this app has no practical use that google wouldn't offer already, it was
            a fun demonstration of the ability to make API calls and render using vanilla web
            languages.
          </p>
        </div>
      </div>
      <hr />
      {/* Project 4 */}
      <div className="projectview__project">
        <div className="projectview__info">
          <a href="https://lighten-up-friend.herokuapp.com">
            <h1>Joke APP</h1>
          </a>
          <h3>ReactJS / PHP / SQL / REST</h3>
          <p>
            Bewarned that this joke app pulls some frankly crude jokes, but they do make for a good
            laugh! This app was built using reactJS as a front-end with a PHP server to store data
            in a Postgres SQL database. It allows the user to get random jokes or add their own!
          </p>
        </div>
        <div className="projectview__picture">
          <img alt="project 4 demo" src="jokeAppDemo.png" />
        </div>
      </div>
    </div>
  );
}

export default ProjectView;
